import React, { lazy, Suspense, useState, useEffect } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '../../../utils/webpack/chunkRetry';
import { Props } from './Video';

const VideoLazy = lazy(() =>
  retry(() => import(/* webpackChunkName: "vlitejs-player" */ './Video'))
);

export const LoadablePlayer: React.FC<Props> = props => {
  const [mounted, setMounted] = useState<boolean>(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <ErrorBoundary debugComponent="LoadablePlayer">
      {mounted && (
        <Suspense fallback={<LoadingIndicator coverMode />}>
          <VideoLazy {...props} />
        </Suspense>
      )}
    </ErrorBoundary>
  );
};

LoadablePlayer.displayName = 'LoadablePlayer';

export default LoadablePlayer;
